export class DeliveryViewModel {
    deliveryId: string | undefined;
    Description: string | undefined;
}